import {getRequest,postRequest, requestAuthority } from '@/sealFilter/requestAuthority'
// 获取主页面的信息
let actionselect=(data)=>postRequest('/link/action/select',data);
// 首页参会人数
let actionindexData=(data)=>postRequest('/index/action/indexData',data);
// 展示购物车数据
let shoppingCartnum=(data)=>postRequest('/shoppingCart/action/total',data);
//特色推荐排行
let featuredrecommendationranking=(data)=>postRequest('/link/action/top',data);     
//出版社排行 
let publishinghouseranking=(data)=>postRequest('/portal/toppub/action/search',data);     

// 首页参会人数  
let actionscroll=(data)=>postRequest('/index/action/scroll',data);

// 购物车数量
let actionlistnum = (data)=>postRequest('/shoppingCart/action/list',data)

// 搜索结果 
let getsearchresult = (data)=>postRequest('/rmdsupport/action/search',data) 
// 获取出版社信息
let obtainpublishinghouseinformation = (data)=>postRequest('/rmdsupport/action/search',data) 
// 获取数据
let getdiFangdata = (data)=>postRequest('/rmdsupport/action/search',data) 
// 获取详情
let getdetails = (data)=>postRequest('/org/action/page',data) 
// 分页查询出版社
let  actionpage =(data)=>postRequest('/ExhibitionPublisher/action/page',data)
// 加入到购物车【通知后台添加商品到购物车】
let  actionsave =(data)=>postRequest('/shoppingCart/action/save',data)
// 生成订单
let  ordersave =(data)=>postRequest('/order/action/save',data)
let  addMoreOrder =(data)=>postRequest('/shoppingCart/action/batchSave2',data)
let  addMoreOrderBookTemp =(data)=>postRequest('/blsCart/action/batchSave2',data)

let  getbeforeAddCar =(data)=>postRequest('/goods/action/check',data)
let  getgiddd =(data)=>postRequest('/rmdsupport/action/search',data)
let  getqueryPubTree =(data)=>postRequest('/org/action/page',data)
let  getUserlistsss =(data)=>postRequest('/user/action/list',data)
let  actionlist =(data)=>postRequest('/shoppingCart/action/checklist',data)

let  actionlist2 =(data)=>postRequest('/shoppingCart/action/list',data)
// 批量修改删除
let  actionbatchDelete =(data)=>postRequest('/shoppingCart/action/batchDelete',data)
let  getqueryTypes =(data)=>postRequest('/shoppingCart/action/batchDelete',data)
// 联合体
let  selectUnionPublisher =(data)=>postRequest('/exhibitionPublisher/action/selectUnionPublisher',data)

let  getXuekefenleiList =(data)=>postRequest('/rmdsupport/action/getXuekefenleiList',data)
// 书本详情页
let  actionbyId =(data)=>postRequest('/exhibitionGood/action/byId',data)

// 删除订单
let  actiondelete =(data)=>postRequest('/shoppingCart/action/delete',data)

// Marc信息
let  selectMacrByGoodsId =(data)=>postRequest('/exhibitionGood/action/selectMacrByGoodsId',data)

let  getApiData =(data)=>postRequest('/rmdsupport/action/getDazhongfenleiList',data)

let  getDataListss =(data)=>postRequest('/bls/action/search',data)
//一次性生成购物车里的订单 
let  allOrdersave =(data)=>postRequest('/order/action/saveAll',data)
// 订单列表
let  listOrders =(data)=>postRequest('/order/action/listOrders',data)

//清空购物车所有数据
let  actionClearAll =(data)=>postRequest('/shoppingCart/action/clearAll',data)

//查询购物车统计总册数、总种数、总价
let  allAmount =(data)=>postRequest('/shoppingCart/action/amount',data)

//订单结算
let  balanceOrder =(data)=>postRequest('/order/action/balance',data)

// 订单详情  
let  byId =(data)=>postRequest('/order/action/byIdList',data)

// 导出订单
let  exportOrder =(data)=>postRequest('/order/action/exportOrderStream',data)

// 导出全部订单
let  exportAllOrder =(data)=>postRequest('/order/action/all',data)

// 发送验证码
let  getsendverificationcode =(data)=>postRequest('/userlogin/action/sendCode',data)

// 专业联合体-具体出版社
let  exhibitionPublisherlist =(data)=>postRequest('/exhibitionPublisher/action/list',data)
// 总码样
let  zongmayang =(data)=>postRequest('/link/action/data',data)
let  prepare =(data)=>postRequest('/rmd/rmdsetting/get',data)
// 商品展示
// pageNum：第几页；pageSize：每页的数量
// activityTag：1精品大码洋 ，2畅销书，3医学， 4抗疫图书，5少儿专区，6推荐书单，7工具书
// publisherId  具体出版社ID
// cnIbraryType  中图法类别代码
// publicType  大众类别标识
// subjectId  学科类别标识
let  pageExhibitionGood =(data)=>postRequest('/exhibitionGood/action/pageOrder',data)


// 批量修改数量
let  actionbatchSave =(data)=>postRequest('/shoppingCart/action/batchSave',data)


//批量修改全部数量
let  updateAmountAll =(data)=>postRequest('/shoppingCart/action/updateAmountAll',data)


// 导出Marc
let  exportMarc =(data)=>postRequest('/order/action/exportMarc',data)

// 排行前一百
let  topt =(data)=>postRequest('/link/action/top100',data)

//砸金蛋活动
let  goldeggsmashingactivity =(data)=>postRequest('/gold/activate/getnowactivate',data)
//是否自主注册
let  showindependently =(data)=>postRequest('userlogin/action/getplatrule',data)
//是否荐购直邮
let  isRmdPost =(data)=>postRequest('userlogin/action/getplatrulebyuserid',data)
// 所有联合体  
let  actionlistAll =(data)=>postRequest('/exhibitionPublisher/action/listAll',data)
// 推荐
let  similarrecommendations =(data)=>postRequest('/exhibitionGood/action/rmdBook',data)
//查询有活动的供应商
let  goldeggsids =(data)=>postRequest('/gold/activate/currList',data)
//查询有活动的供应商
let  duoshaoxiangtongxuanzhe =(data)=>postRequest('/col/action/ratio',data)

//查询有活动的供应商
let  genghuanguanggaowei =(data)=>postRequest('/index/action/position',data)

//添加埋点
let insertPointFun =(data)=>postRequest('/tk/action/insert',data)
//图表1
let publicationyearandmonthstatistics =(data)=>postRequest('/order/action/stat',data)
//获取重点推荐列表
let getkeyrecommendationsdata =(data)=>postRequest('/rmdsupport/action/bookListing',data)

export{
    actionlist,actionlist2,getkeyrecommendationsdata, actionselect,actionindexData,actionscroll,shoppingCartnum,selectUnionPublisher,actionbyId,selectMacrByGoodsId,getApiData,actiondelete,
  featuredrecommendationranking,actionbatchDelete,getqueryTypes,getXuekefenleiList,getDataListss,exportOrder,exhibitionPublisherlist,goldeggsmashingactivity,zongmayang,
  getdetails,addMoreOrder,showindependently,isRmdPost,getbeforeAddCar,getgiddd,addMoreOrderBookTemp,getqueryPubTree,getUserlistsss,exportAllOrder,exportMarc,actionlistAll,goldeggsids,genghuanguanggaowei,
  publishinghouseranking,getsearchresult, obtainpublishinghouseinformation,allOrdersave,publicationyearandmonthstatistics,pageExhibitionGood,actionbatchSave,updateAmountAll,duoshaoxiangtongxuanzhe,
   getdiFangdata,  actionpage,actionsave,ordersave,prepare,actionlistnum,listOrders,actionClearAll,allAmount,balanceOrder,byId,similarrecommendations,topt,insertPointFun,getsendverificationcode
}












// WEBPACK FOOTER //
// ./src/api/pages.js